/**
 * @param {string} search a search portion of a URL, for example: '?lwpaymentid=PAY-1AB23456CD7890123EF45678'
 */
const parseUrlSearchParams = (search) => {
	return Object.fromEntries(new URLSearchParams(search).entries(search));
};

export default parseUrlSearchParams;
